import {StoreItemCategory} from '../../../../shared/entity_datas/StoreEnums'
import {BaseStoreItem} from '../../../../shared/store/BaseStoreItem'
import {ColonistMembershipProduct} from '../../../../shared/store/ColonistMembershipProduct'
import {UIMembershipProductView} from './UIMembershipProductView'
import {UIStoreMembershipTabsController} from './UIStoreMembershipTabsController'
import {GiftedMembershipItem} from '../../../../shared/store/UserItems'
import {PaymentMethod} from '../../../../shared/store/BaseColonistStoreProduct'
import {UIStoreGiftOverlayController} from './gift/UIStoreGiftOverlayController'

export abstract class UIStoreBodyController {
    readonly membershipItems: UIMembershipProductView[] = []
    giftOverlayController: UIStoreGiftOverlayController
    abstract readonly membershipTabsController: UIStoreMembershipTabsController

    abstract updateCategoryItems(category: StoreItemCategory, container: HTMLDivElement)
    abstract updateOwnedItems(ownedItems: BaseStoreItem[])
    abstract updateSubscribedItems(ownedMembership: ColonistMembershipProduct | undefined, paymentMethod: PaymentMethod | undefined)
    abstract updateOwnedMembership(ownedMembership: ColonistMembershipProduct | undefined, paymentMethod: PaymentMethod | undefined)
    abstract updatePriceForFounderPack(ownedItems: BaseStoreItem[])
    abstract updateGiftedMemberships(memberships: GiftedMembershipItem[])
}
